var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpowerplantLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 114,
    viewBox: "0 0 93 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 114,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5685 78.2132C36.8105 87.9713 36.8105 103.81 46.5685 113.569L8.38478 75.3848C-1.79756 65.2024 -1.79756 48.7976 8.38478 38.6152L46.5685 0.431458C56.3266 10.1895 56.3266 26.0287 46.5685 35.7868L25.3553 57L46.5685 65.061V78.2132Z",
    fill: "#DDDC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5685 35.7868C56.3266 26.0287 56.3266 10.1895 46.5685 0.431458L84.7523 38.6152C94.9346 48.7976 94.9346 65.2024 84.7523 75.3848L46.5685 113.569C36.8105 103.81 36.8105 87.9713 46.5685 78.2132L67.7817 57L46.5685 48.939V35.7868Z",
    fill: "#9BA547"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 114,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerplantLogo);
export default __webpack_public_path__ + "static/media/empowerplant-logo.b5e8a88c0b29b0966f11e638088e68df.svg";
export { ForwardRef as ReactComponent };